import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

const AttributesIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.5 4.6875C2.55208 4.11458 2.86458 3.80208 3.4375 3.75H21.5625C22.1354 3.80208 22.4479 4.11458 22.5 4.6875C22.4479 5.26042 22.1354 5.57292 21.5625 5.625H3.4375C2.86458 5.57292 2.55208 5.26042 2.5 4.6875ZM16.875 8.75C17.3958 8.77604 17.8385 8.95833 18.2031 9.29688C18.5417 9.66146 18.724 10.1042 18.75 10.625V14.375C18.724 14.8958 18.5417 15.3385 18.2031 15.7031C17.8385 16.0417 17.3958 16.224 16.875 16.25H8.125C7.60417 16.224 7.16146 16.0417 6.79688 15.7031C6.45833 15.3385 6.27604 14.8958 6.25 14.375V10.625C6.27604 10.1042 6.45833 9.66146 6.79688 9.29688C7.16146 8.95833 7.60417 8.77604 8.125 8.75H16.875ZM16.875 10.625H8.125V14.375H16.875V10.625ZM21.5625 19.375C22.1354 19.4271 22.4479 19.7396 22.5 20.3125C22.4479 20.8854 22.1354 21.1979 21.5625 21.25H3.4375C2.86458 21.1979 2.55208 20.8854 2.5 20.3125C2.55208 19.7396 2.86458 19.4271 3.4375 19.375H21.5625Z"
            fill="#00CA3D"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: AttributesIcon,
    title: metadata.title,
    edit: Edit,
});
